const USUARIO_PERFIL = {
  cs: {
    id: 'cs',
    descricao: 'Consulta',
    prioridade: 9,
    helpText: 'Visualização de informações e relatórios.'
  },
  us: {
    id: 'us',
    descricao: 'Usuário Padrão',
    prioridade: 6,
    helpText: 'Pode consultar informações e gerar relatórios.'
  },
  op: {
    id: 'op',
    descricao: 'Operador',
    prioridade: 4,
    helpText: 'Pode consultar, gerar e configurar relatórios.'
  },
  ad: {
    id: 'ad',
    descricao: 'Administrador',
    prioridade: 2,
    helpText: 'Gerencia relatórios e configurações da entidade, incluindo assinaturas.'
  },
  sp: {
    id: 'sp',
    descricao: 'Super usuário',
    prioridade: 0,
    helpText: 'Acesso completo a todas as funcionalidades, configurações e permissões.'
  }
};

export default USUARIO_PERFIL;
